export default (theme) => ({
    root: {
        height: '100%',
        width: '100%',
        position: 'relative',
        userSelect: 'none',
    },
    minimalist: {
        '& $slideImage': {
            cursor: 'pointer',
        },
    },
    embedded: {
        '& $slideWrapper': {
            borderRadius: 0,
            backgroundColor: theme.colors.transparent,
        },
    },
    slideWrapper: {
        position: 'relative',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        borderRadius: 8,
        backgroundColor: theme.colors.grey[100],
    },
    slidesTrack: {
        display: 'flex',
        height: '100%',
        transition: 'transform 0.4s ease-out',
    },
    slide: {
        flex: '0 0 100%',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    slideImage: {
        width: '100%',
        height: '100%',
        objectFit: 'scale-down',
    },
    navButton: {
        color: theme.colors.primary.white,
        transition: 'opacity 0.3s ease-out',
        appearance: 'none',
        backgroundColor: theme.colors.transparent,
        border: 0,
        cursor: 'pointer',
        outline: 'none',
        position: 'absolute',
        zIndex: 4,
        padding: '50px 10px',
        top: '50%',
        transform: 'translateY(-50%)',
        filter: theme.effects.boxShadow,
        '&:disabled': {
            cursor: 'default',
            opacity: 0.3,
        },
        '&:focus': {
            outline: 'none',
        },
    },
    navLeft: {
        extend: 'navButton',
        left: 0,
    },
    navRight: {
        extend: 'navButton',
        right: 0,
    },
    fullscreenButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: 8,
        appearance: 'none',
        backgroundColor: theme.colors.transparent,
        border: 0,
        cursor: 'pointer',
        outline: 'none',
        zIndex: 4,
        filter: theme.effects.boxShadow,
        '&:focus': {
            outline: 'none',
        },
    },
    fullscreenOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.primary.black,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
    },
    fullscreenContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    fullscreenClose: {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: 8,
        appearance: 'none',
        backgroundColor: theme.colors.transparent,
        border: 0,
        cursor: 'pointer',
        outline: 'none',
        zIndex: 10,
        filter: theme.effects.boxShadow,
        '&:focus': {
            outline: 'none',
        },
    },
    fullscreenSlideWrapper: {
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        minHeight: 0,
    },
    fullscreenSlidesTrack: {
        display: 'flex',
        height: '100%',
        transition: 'transform 0.4s ease-out',
    },
    fullscreenSlide: {
        flex: '0 0 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        padding: '0 60px',
        boxSizing: 'border-box',
    },
    fullscreenImage: {
        maxWidth: '100%',
        maxHeight: 'calc(100vh - 140px)',
        objectFit: 'contain',
    },
    thumbnailsWrapper: {
        padding: '16px 0',
        overflow: 'hidden',
    },
    thumbnailsContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: 8,
        flexWrap: 'wrap',
    },
    thumbnail: {
        appearance: 'none',
        backgroundColor: theme.colors.transparent,
        border: `2px solid ${theme.colors.transparent}`,
        borderRadius: 4,
        cursor: 'pointer',
        padding: 0,
        overflow: 'hidden',
        transition: 'border-color 0.2s ease-out',
        '&:focus': {
            outline: 'none',
        },
    },
    thumbnailActive: {
        borderColor: theme.colors.primary.white,
    },
    thumbnailImage: {
        width: 80,
        height: 80,
        objectFit: 'cover',
        display: 'block',
    },
    '@media (max-width: 768px)': {
        fullscreenButton: {
            padding: 15,
        },
        fullscreenClose: {
            padding: 15,
        },
        thumbnailImage: {
            width: 60,
            height: 60,
        },
    },
    '@media (max-width: 480px)': {
        fullscreenButton: {
            padding: 10,
        },
        fullscreenClose: {
            padding: 10,
        },
        fullscreenSlide: {
            padding: '0 40px',
        },
        thumbnailImage: {
            width: 50,
            height: 50,
        },
    },
});
